import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import moment from 'moment';
import { Link } from 'react-router-dom';
import CalendarRooms from './CalendarRooms';
import CalendarEquipments from './CalendarEquipments';
import CalendarHeader from './CalendarHeader';

class BookingCalendar extends Component {
  constructor(props) {
    super(props);
    // start date project
    this.startDateProject = moment(this.props.project.start_date);
    // end date project
    this.endDateProject = moment(this.props.project.end_date);

    // range date
    this.dateRangeProject = [this.startDateProject, this.endDateProject];
    this.state = {
      month: this.startDateProject.clone()
    };
  }

  render() {
    if (this.props.project.start_date === null || this.props.project.end_date === null) {
      return (
        <p>
          Project does not have a start or end date.
          <Link to={`/projects/${this.props.project.id}`}>
            {' '}
            Please edit the project to be able to book equipment.{' '}
          </Link>
        </p>
      );
    }
    return (
      <div className="booking__calendar">
        {/* <div className='booking__calendar-actions'> */}
        {/* <Button */}
        {/* className = "action edit-date" */}
        {/* //onClick   = {'#'} */}
        {/* > */}
        {/* <span className="dates">{this.startDateProject.format('D MMMM')} to {this.endDateProject.format('D MMMM')} </span> */}
        {/* <span className="duration">Duration: {this.endDateProject.diff(this.startDateProject,'days')} days </span> */}
        {/* <i className="icon-edition icon"></i> */}
        {/* </Button> */}

        {/* <Button */}
        {/* className = "action equipments" */}
        {/* //onClick   = {'#'} */}
        {/* > */}
        {/* <span>Equipment requirement</span> */}
        {/* <i className="icon-list icon"></i> */}
        {/* </Button> */}

        {/* <Button */}
        {/* className = "action see-whole-calendar" */}
        {/* //onClick   = {'#'} */}
        {/* > */}
        {/* <span>See whole calendar</span> */}
        {/* <i className="icon-calendar icon"></i> */}
        {/* </Button> */}
        {/* </div> */}

        <CalendarHeader
          // start_date={this.props.project.start_date}
          // end_date={this.props.project.end_date}
          disableHistory={this.props.disableHistory}
        />

        {this.props.bookingRooms.length ? (
          <div className="booking__calendar-rooms">
            <div className="booking__calendar-rooms-content">
              <h5 className="booking__calendar-rooms-title booking__calendar-section-title">
                {'Localistation'}
              </h5>
              <div className="booking__calendar-rooms-table table_wrapper">
                <CalendarRooms
                  bookingRooms={this.props.bookingRooms}
                  month={this.state.month}
                  dateRange={this.dateRangeProject}
                />
              </div>
            </div>
          </div>
        ) : (
          ''
        )}

        {this.props.bookingEquipments.length ? (
          <div className="booking__calendar-equipments">
            {this.props.bookingEquipments.map((dataAcquisition, index) => {
              return (
                <div key={dataAcquisition.name} className="booking__calendar-equipment-content">
                  <h5 className="booking__calendar-equipment-title booking__calendar-section-title">
                    {`${
                      dataAcquisition.data_acquisition_source_equipment.equipment_hardware.name
                    } ${index + 1}`}
                  </h5>
                  <div className="booking__calendar-equipment-table table_wrapper">
                    <CalendarEquipments
                      equipment_hardware_instances={
                        dataAcquisition.data_acquisition_source_equipment.equipment_hardware
                          .equipment_hardware_instances
                      }
                      dataAcquisitionSourceEquipmentId={
                        dataAcquisition.data_acquisition_source_equipment.id
                      }
                    />
                  </div>
                </div>
              );
            })}
          </div>
        ) : (
          ''
        )}
      </div>
    );
  }
}

BookingCalendar.propTypes = {
  disableHistory: PropTypes.bool
};

BookingCalendar.defaultProps = {
  disableHistory: false
};

export default connect(state => ({
  project: state.projects.single.active,
  bookingEquipments: state.projects.single.booking.equipments,
  bookingRooms: state.projects.single.booking.rooms,
  bookingUsers: state.projects.single.booking.users,
  currentDaysSelection: state.projects.single.booking.currentSelection
}))(BookingCalendar);



// WEBPACK FOOTER //
// ./src/scenes/projects/scenes/singleProject/components/booking/BookingCalendar.js